// 읽음 버튼 (글/접수 상세 공통).
//  - 표시: 현재 읽음수. 아직 안 읽었으면 클릭 시 서버 +1 → 이 기기·이 버전을 읽음 처리.
//  - 이미 이 버전을 읽었으면 '읽음 완료'로 비활성(동일 기기 중복 불가).
//  - version(=updatedAt)이 바뀌면(대상 수정) 다시 활성화되어 재카운트 가능.
import { useEffect, useState } from 'preact/hooks';
import { hasRead, markRead, type ReadKind } from '../core/readTracker';

interface Props {
  kind: ReadKind;
  id: number;
  /** 대상의 현재 버전(updatedAt). 바뀌면 읽음 상태가 초기화된다. */
  version: string;
  /** 서버가 내려준 현재 읽음수 */
  count: number;
  /** 읽음수 +1 요청. 갱신된 읽음수를 반환. */
  onIncrement: () => Promise<{ readCount: number }>;
  /** 증가 후 부모에 새 읽음수 통지(목록/상세 동기화용, 선택) */
  onCounted?: (readCount: number) => void;
}

export function ReadButton({ kind, id, version, count, onIncrement, onCounted }: Props) {
  const [current, setCurrent] = useState(count);
  const [read, setRead] = useState(false);
  const [busy, setBusy] = useState(false);

  // 대상/버전/서버카운트가 바뀌면 상태 재동기화.
  useEffect(() => {
    setCurrent(count);
    setRead(hasRead(kind, id, version));
  }, [kind, id, version, count]);

  const click = async () => {
    if (read || busy) return;
    setBusy(true);
    try {
      const { readCount } = await onIncrement();
      setCurrent(readCount);
      markRead(kind, id, version);
      setRead(true);
      onCounted?.(readCount);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      class={`btn read-btn ${read ? 'read-btn--done' : ''}`}
      disabled={read || busy}
      onClick={click}
      title={read ? '이미 읽음 처리한 내용입니다.' : '내용을 다 읽었으면 눌러 주세요.'}
    >
      {read ? '✓ 읽음' : '읽음'} <span class="read-btn__count">{current}</span>
    </button>
  );
}
